/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Profile_ReloadInputs */

const en_company_profile_reload = /** @type {(inputs: Company_Profile_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reload`)
};

const de_company_profile_reload = /** @type {(inputs: Company_Profile_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neu laden`)
};

/**
* | output |
* | --- |
* | "Reload" |
*
* @param {Company_Profile_ReloadInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_profile_reload = /** @type {((inputs?: Company_Profile_ReloadInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Profile_ReloadInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_profile_reload(inputs)
	return en_company_profile_reload(inputs)
});